import React from "react";

// Primary action button. `loading` shows an inline spinner and disables.
export default function Button({
  children,
  onClick,
  disabled,
  loading,
  variant = "primary",
  type = "button",
  className = "",
}) {
  return (
    <button
      type={type}
      className={`btn btn-${variant} ${className}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading && <span className="btn-spinner" />}
      <span>{children}</span>
    </button>
  );
}
